export default {
  en: {
    about: "About",
    contactUs: "Contact Us",
    gallery: "Gallery",
    loadMore: "Load More",
    year: "Year",
    home: "Home",
    pageNotFound: "Page Not Found",
    backToHome: "Back to Home",
    noResultFound: "No Result Found",
    view: "View",
    biography: "Biography",
    viewPhotoGallery: "View Photo Gallery",
    khayatsPersonalGallery: "Khayat's Personal Gallery",
    artWorks: 'Art Works',
    collections: 'Collections',
    drawings: 'Drawings',
    paintings: 'Paintings',
    stones: 'Stones',
    unfinishedworks: 'Unfinished Works',
    mediaAndArchive: 'Media & Archive',
    videos: 'Videos',
    books: 'Books',
    writings: 'Writings',
    legacy: 'Legacy',
    internationalacclaims: 'International acclaims',
    exhibitions: 'Upcoming Exhibition',
    impactonart: 'Impact on art',
    achievements: 'Achievements',
    projects: 'Projects',
    menu: 'Menu',
    close: 'Close',
    photoGallery: 'Photo Gallery',
    ismailKhayat: 'Ismail Khayat',
    artGallery: 'Art Gallery',
    backToTop: 'Back to Top',
    more: 'More',
    moreFromThisCollection: 'More from this collection',
    website: 'Website',
    back: 'Back',
    collection: 'Collection',
    all: 'All',
    yearDropdown: 'Year',
    allArtWorks: 'All Art Works',
    international: 'International acclaims',
    impact: 'Impact on art',
    loading: 'Loading',
    project: 'Project',
    infinity: 'Infinity',
    ismailKhayatArtGallery: 'Ismail Khayat Art Gallery',
    allRightReserved: 'All Rights Reserved',
    websiteBy: 'Website by',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    showMore: 'Show More',
    showLess: 'Show Less',
    getInTouch: 'Get In Touch',
    fullName: 'Full Name',
    message: 'Message',
    submit: 'Submit',
    tryAgainLater: 'Try again later',
    feelFreeToContactUs: 'feel free to contact us if you have any questions',
    messageHasBeenSentSuccessfully: 'Message has been sent successfully',
    download: 'Download',
  },

  ku: {
    about: "دەربارە",
    contactUs: "پەیوەندی",
    gallery: "گەلەری",
    biography: "ژیاننامە",
    loadMore: "زیاتر",
    year: "ساڵی",
    home: "سەرەتا",
    pageNotFound: "ئەم پەڕەیە بوونی نییە",
    backToHome: "گەڕانەوە بۆ سەرەتا",
    noResultFound: "هیچ ئەنجامێك نەدۆزرایەوە",
    view: "بینین",
    viewPhotoGallery: 'بینینی گەلەری وێنە',
    khayatsPersonalGallery: 'گەلەری تایبەتی خەیات',
    artWorks: 'کاری هونەری',
    collections: 'کۆکراوەکان',
    drawings: 'هێڵکاری',
    paintings: 'تابلۆکان',
    stones: 'بەردەکان',
    unfinishedworks: 'کاری تەواونەکراو',
    mediaAndArchive: 'تۆمار و ئەرشیف',
    videos: "ڤیدیۆکان",
    books: "پەرتووکەکان",
    writings: 'نووسراوەکان',
    legacy: 'میرات',
    internationalacclaims: 'بانگێشی نێودەوڵەتی',
    exhibitions: 'پێشانگاکان',
    impactonart: 'کاریگەری لەسەر هونەر',
    achievements: 'دەسکەوتەکان',
    projects: 'پرۆژەکان',
    menu: 'پێڕست',
    close: 'داخستن',
    photoGallery: 'گەلەری وێنە',
    ismailKhayat: 'ئیسماعیل خەیات',
    artGallery: 'گەلەری هونەری',
    backToTop: 'گەڕانەوە بۆ سەرەوە',
    more: "زیاتر",
    moreFromThisCollection: 'زیاتر لەسەر ئەم کۆکراوەیە',
    website: 'ویبسایت',
    back: 'گەڕانەوە',
    collection: 'کۆکراوە',
    all: 'هەموو',
    yearDropdown: 'ساڵ',
    allArtWorks: 'هەموو کارە هونەریەکان',
    international: 'بانگێشی نێودەوڵەتی',
    impact: 'کاریگەری لەسەر هونەر',
    loading: 'چاوەڕوانبە',
    project: 'پرۆژە',
    infinity: 'بێ کۆتا',
    ismailKhayatArtGallery: 'گەلەری هونەری ئیسماعیل خەیات',
    allRightReserved: 'هەموو مافەکان پارێزراون',
    websiteBy: 'دروستکراوە لە لایەن',
    email: 'ئیمەیڵ',
    phone: 'ژمارەی موبایل',
    address: 'ناونیشان',
    showMore: 'زیاتر',
    showLess: 'کەمتر',
    getInTouch: 'پەیوەندی بکە',
    fullName: 'ناوی تەواو',
    message: 'پەیام',
    submit: 'ناردن',
    tryAgainLater: 'تکایە کاتێکی کە هەوڵ بدەرەوە',
    feelFreeToContactUs: 'پەیوەندیمان پێوە بکە لە کاتی هەبوونی هەر پرسیارێک',
    messageHasBeenSentSuccessfully: 'پەیامەکەت ناردرا',
    download: 'داگرتن',
  },
};
